// extracted by mini-css-extract-plugin
module.exports = {"upload-wrap":"Attachments_style_upload-wrap__2cZUs","other-item":"Attachments_style_other-item__UO5ue"};